export interface PasswordRuleState {
  minLength: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
}

export const PASSWORD_RULES_MESSAGE =
  'Password must be at least 8 characters and contain uppercase, lowercase and number';

export const getPasswordRuleState = (password: string): PasswordRuleState => ({
  minLength: password.length >= 8,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /\d/.test(password),
});

export const meetsPasswordRules = (password: string): boolean =>
  Object.values(getPasswordRuleState(password)).every(Boolean);

export const isBlankPassword = (password: string | null | undefined): boolean =>
  !password || password.trim().length === 0;
